import React from 'react';

type Props = {
  color?: string;
  width?: number;
};
export default function Courses({ color = '#0C57FF', width = 16 }: Props) {
  return (
    <svg
      width={width}
      height={width * (18 / 16)}
      viewBox={`0 0 16 18`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_675_1367)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1211 4.2096L13.0991 4.20954V3.01052C13.0991 2.73601 12.9219 2.50278 12.6823 2.46217C12.6405 2.45505 11.6448 2.29114 10.4459 2.53839C9.10929 2.81401 8.04333 3.49372 7.32037 4.52127C6.59736 3.49372 5.5314 2.81401 4.19485 2.53839C2.99586 2.2912 2.00019 2.45505 1.95842 2.46217C1.71885 2.50284 1.54164 2.73607 1.54164 3.01052V4.20954H0.519613C0.249465 4.20954 0.0303726 4.45784 0.0303726 4.76407V15.2129C0.0303726 15.3924 0.107053 15.5608 0.236211 15.6648C0.365369 15.7689 0.530953 15.7956 0.680533 15.7365C0.717253 15.7221 4.38351 14.304 7.11733 15.7173C7.24634 15.784 7.39445 15.784 7.52346 15.7173C10.2496 14.308 13.9237 15.7222 13.9603 15.7365C14.0127 15.7572 14.067 15.7674 14.1211 15.7674C14.2214 15.7674 14.3206 15.7324 14.4046 15.6649C14.5337 15.5609 14.6104 15.3924 14.6104 15.2129V4.76412C14.6104 4.4579 14.3913 4.2096 14.1211 4.2096ZM1.0089 14.4709V5.31854H1.54164V12.7029C1.54164 12.8641 1.60383 13.0171 1.71139 13.1224C1.81895 13.2277 1.962 13.2749 2.1026 13.2514C2.1296 13.2469 4.25504 12.9162 5.80788 14.1237C3.89505 13.753 1.98061 14.1818 1.0089 14.4709ZM6.83113 13.6237C6.1472 12.9233 5.25634 12.4497 4.19485 12.2309C3.68401 12.1255 3.21009 12.0948 2.83111 12.0948C2.71859 12.0948 2.61442 12.0975 2.52021 12.1018V3.5197C3.46055 3.47163 5.74799 3.58558 6.83113 5.66654V13.6237ZM7.80961 5.6666C8.88888 3.59454 11.1799 3.47542 12.1206 3.5211V12.1018C11.709 12.083 11.1083 12.0942 10.4459 12.2309C9.3844 12.4497 8.49355 12.9233 7.80961 13.6237V5.6666ZM8.83124 14.1241C10.3843 12.9159 12.5109 13.2469 12.5374 13.2513C12.6783 13.2753 12.8213 13.2284 12.9292 13.1231C13.0371 13.0177 13.0991 12.8644 13.0991 12.7029V5.31859H13.6318V14.4709C12.6598 14.1817 10.7446 13.7527 8.83124 14.1241Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_675_1367">
          <rect
            width="15"
            height="17"
            fill="white"
            transform="translate(0.0303726 0.834961)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
